/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { changeJingleOrderModelSchema } from "../changeJingleOrderModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const postApiJingleCollectionsIdOrderPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор подборки")
    })

/**
 * @description Идентификатор обновляемой подборки
 */
export const postApiJingleCollectionsIdOrder200Schema = z.lazy(() => unitSchema)

/**
 * @description Подборка уже существует
 */
export const postApiJingleCollectionsIdOrder400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiJingleCollectionsIdOrder401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiJingleCollectionsIdOrder403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Подборка не найдена
 */
export const postApiJingleCollectionsIdOrder404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiJingleCollectionsIdOrder500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiJingleCollectionsIdOrderMutationRequestSchema = z.lazy(() => changeJingleOrderModelSchema).describe("Тело запроса")

export const postApiJingleCollectionsIdOrderMutationResponseSchema = z.lazy(() => postApiJingleCollectionsIdOrder200Schema)